import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  chatMembersModalChannelName,
  chatMembersModalDate,
  chatMembersModalList,
  chatMembersModalOpened,
} from '../../../../../redux/healthboard/patientPortal/selectors';
import { chatMembersModalActions } from '../../../../../redux/healthboard/patientPortal/chat-members-modal';
import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../../../../redux/context/selectors';

const mapStateToProps = state => ({
  openedChatMembersModal: chatMembersModalOpened(state),
  mainUserId: loggedUserIdSelector(state),
  targetUserId: targetUserIdSelector(state),
  memberList: chatMembersModalList(state),
  channelName: chatMembersModalChannelName(state),
  date: chatMembersModalDate(state),
});

const mapDispatchToProps = {
  close: chatMembersModalActions.close,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/ChatMembersModal/enhance.js